function Qual() {
  return (
    <div className="text-center">
      <ul>
        <li>
          <h3> بكالوريوس حاسبات ومعلومات</h3>
          <p>
            <a
              className="fs-4 p-1 text-decoration-none"
              href="https://www.facebook.com/FCI.ZU.Formal.Page"
              target="_blank"
              rel="noreferrer"
            >
              جامعة الزقازيق
            </a>
          </p>
        </li>
      </ul>
    </div>
  );
}
export default Qual;
